// extracted by mini-css-extract-plugin
module.exports = {"minimumEnvText":"style-module_minimumEnvText__2HEip9i0qizHTef9Rzec-N","minCompleteLabel":"style-module_minCompleteLabel__1jyElQKKd52oH93hpOaKOR"};